import {fsa, fsaPayload, fsaPayloadByKeys} from './helpers'

export const ADD_PARTICIPANT_TO_ORDER = 'add participant to checked-out order'
export const addParticipantToOrder = fsaPayload(ADD_PARTICIPANT_TO_ORDER)

export const CANCEL_PARTICIPANT_ORDER = 'cancel participant order and remove from event'
export const cancelParticipantOrder = fsaPayloadByKeys(CANCEL_PARTICIPANT_ORDER, ['orderId'])

export const CANCEL_PARTICIPANT_ORDER_SUCCESS = 'cancel and removal of participant order succeeded'
export const cancelParticipantOrderSuccess = fsaPayload(CANCEL_PARTICIPANT_ORDER_SUCCESS)

export const CLEAR_EVENT_AND_ORDER_DETAILS = 'clear out event and order details'
export const clearEventAndOrderDetails = () => ({type: CLEAR_EVENT_AND_ORDER_DETAILS})

export const EDIT_PARTICIPANT = 'edit existing participant'
export const editParticipant = fsaPayload(EDIT_PARTICIPANT)

export const EDIT_PARTICIPANT_SUCCESS = 'edit existing participant succeeded'
export const editParticipantSuccess = fsaPayload(EDIT_PARTICIPANT_SUCCESS)

export const GET_EVENT_AND_ORDER_DETAILS = 'get event and order details'
export const getEventAndOrderDetails = (eventId) => ({
  type: GET_EVENT_AND_ORDER_DETAILS,
  payload: {eventId},
})

export const GET_EVENT_AND_ORDER_DETAILS_FAILURE = 'get event and order details failure'

export const GET_EVENT_AND_ORDER_DETAILS_PENDING = 'get event and order details pending'

export const GET_EVENT_AND_ORDER_DETAILS_SUCCESS = 'get event and order details succeeded'

export const HIDE_SUCCESS_MESSAGE_BAR = 'hide success message bar'
export const hideSuccessMessageBar = () => ({type: HIDE_SUCCESS_MESSAGE_BAR})

export const SEND_PARTICIPANT_REMINDER = 'send reminder email to participant'
export const sendParticipantReminder = (orderId, callback) => ({
  type: SEND_PARTICIPANT_REMINDER,
  payload: {orderId, callback},
})

export const SHOW_SUCCESS_MESSAGE_BAR = 'show success message bar'
export const showSuccessMessageBar = () => ({type: SHOW_SUCCESS_MESSAGE_BAR})

export const START_FORM_PROCESSING = 'start form processing'
export const startFormProcessing = fsa(START_FORM_PROCESSING)

export const STOP_FORM_PROCESSING = 'stop form processing'
export const stopFormProcessing = fsa(STOP_FORM_PROCESSING)

export const UPDATE_CURRENT_PAGE_DETAILS = 'event manager/update current page details'
export const updateCurrentPageDetails = fsaPayloadByKeys(UPDATE_CURRENT_PAGE_DETAILS, ['orderId'])
